// src/scripts/rotaInvite.js

import {
  app,
} from "@/firebase";

import {
  getFunctions,
  httpsCallable,
} from "firebase/functions";

function lower(s) {
  return String(s ?? "")
    .trim()
    .toLowerCase();
}

function clean(s) {
  return String(s ?? "")
    .trim();
}

function isValidEmail(s) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
    String(s || "").trim()
  );
}

/**
 * Sends Staff App access details to a staff member.
 *
 * IMPORTANT:
 * - This file no longer writes rota_access_by_email directly.
 * - The browser should not be responsible for privileged access records.
 * - sendStaffLoginCodeEmail performs the compatibility
 *   rota_access_by_email write server-side using the Admin SDK.
 * - The email contains the Staff App URL and generated six-digit code.
 */
export async function inviteStaffRotaViewer({
  email,
  venueId,
  staffId = "",
  staffName = "",
  jobTitle = "",
  staffLoginCode = "",
}) {
  const staffEmail =
    lower(email);

  const vId =
    clean(venueId);

  const sId =
    clean(staffId);

  const name =
    clean(staffName);

  const role =
    clean(jobTitle);

  const code =
    clean(staffLoginCode);

  if (
    !staffEmail ||
    !isValidEmail(staffEmail)
  ) {
    throw new Error(
      "Missing/invalid staff email."
    );
  }

  if (!vId) {
    throw new Error(
      "Missing venueId."
    );
  }

  if (!sId) {
    throw new Error(
      "Missing staffId."
    );
  }

  if (!code) {
    throw new Error(
      "Missing staff login code."
    );
  }

  const functions =
    getFunctions(
      app,
      "us-central1"
    );

  const sendStaffLoginCodeEmail =
    httpsCallable(
      functions,
      "sendStaffLoginCodeEmail"
    );

  const response =
    await sendStaffLoginCodeEmail({
      email:
        staffEmail,

      venueId:
        vId,

      staffId:
        sId,

      staffName:
        name ||
        staffEmail,

      jobTitle:
        role,

      staffLoginCode:
        code,
    });

  const result =
    response?.data ||
    {};

  if (
    result?.ok ===
    false
  ) {
    throw new Error(
      result?.error ||
      "Staff App email could not be sent."
    );
  }

  return {
    ok:
      true,

    redirectUrl:
      result?.staffAppUrl ||
      "https://staff.coredeckapp.co.uk",

    staffAppUrl:
      result?.staffAppUrl ||
      "https://staff.coredeckapp.co.uk",

    staffLoginCode:
      code,
  };
}